import { useContext } from 'react';
import DropdownContext from '../contexts/DropdownContext';
/**
 * Hook to use the Dropdown context.
 * @returns Dropdown context.
 */
export const useDropdown = () => {
    const context = useContext(DropdownContext);
    if (context === undefined) {
        throw new Error('Do not use useDropdown hook outside the Dropdown context.');
    }
    return context;
};
//# sourceMappingURL=useDropdown.js.map